<script setup>
import * as yup from "yup";
import {requiredMessage} from "@/utils/yupValidators";
import {useDjangoForm} from "@/utils/forms";
import {createFormData} from "@/csrf";
import {useRoute} from "vue-router";

const emit = defineEmits(['authComplete']);
const route = useRoute();

const schema = yup.object({
    code: yup.string().required(requiredMessage),
});
const {defineField, handleSubmit, setFieldError} = useDjangoForm({
    validationSchema: schema,
});

const [code, codeProps] = defineField('code');

const onSubmit = handleSubmit(async (values) => {
    return tryCompleteAuth(values.code);
});

async function tryCompleteAuth(code) {
    const data = createFormData();
    data.set('code', code);

    const request = new Request(reverseUrl('web:device:auth_complete_api'), {
        method: 'POST',
        body: data,
    });
    return fetch(request)
        .then(async response => {
            const data = await response.json();
            if (!response.ok || !data.successful) {
                throw {
                    data: data,
                };
            }

            return data;
        })
        .then(() => {
            emit('authComplete');
        })
        .catch(error => {
            setFieldError('code', error.data.error);
        });
}

if (route.query.code) {
    tryCompleteAuth(route.query.code);
}
</script>

<template>
    <v-card max-width="640" elevation="8" class="flex-fill my-10">
        <v-card-title>
            {{ pgettext('title', 'Authenticate this device') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
            <v-form @submit.prevent="onSubmit">
                <p class="mb-4">
                    {{ gettext('Please enter the code that was generated when you added the device.') }}
                </p>

                <v-text-field v-model="code"
                              v-bind="codeProps"
                              name="code"
                              variant="outlined"
                              :label="pgettext('label', 'Device Authentication Code')"/>

                <p class="text-center">
                    <v-btn type="submit" color="green">
                        {{ pgettext('action', 'Authenticate') }}
                    </v-btn>
                </p>
            </v-form>
        </v-card-text>
    </v-card>
</template>
